import CustomIcon from './Icon'
import AddIcon from './AddIcon'
import DeleteIcon from './DeleteIcon'
import DragIcon from './DragIcon'
import FileIcon from './FileIcon'
import ToggleIcon from './ToggleIcon'
import VisibilityToggleIcon from './VisibilityToggleIcon'
import { type IconProps } from './Styles'

const Icon = (props: IconProps) => <CustomIcon {...props} />
Icon.Add = AddIcon
Icon.Delete = DeleteIcon
Icon.Drag = DragIcon
Icon.File = FileIcon
Icon.Toggle = ToggleIcon
Icon.VisibilityToggle = VisibilityToggleIcon

export default Icon
